<template>
  <el-container
    :class="['dfx-container', showHeader ? 'dfx-container-header' : '']"
  >
    <el-header v-if="showHeader">
      <Headers />
    </el-header>
    <el-container class="dfx-content">
      <el-aside
        :width="asideWidth"
        class="dfx-aside no-shk"
        :style="{ backgroundColor: bgColog, width: asideWidth }"
        :bgColor="bgColog"
        activeTextColor="#000"
      >
        <div class="logo">
          <el-image
            src="//oss.dianleida.net/1688-web/images/long_logo.png"
          ></el-image>
        </div>
        <Aside />
      </el-aside>
      <el-main class="dfx-views">
        <div class="cmd row-end-center dfx-my-10 dfx-px-20">
          <div class="dfx-mr-12 screen-box" v-if="buildType === 'App' && dldId">
            <el-button size="small" @click="handleFullScreen">
              <div class="dfc">
                <i class="el-icon-full-screen dfx-c-them dfx-f-15"></i>
                <span>{{ fullscreenBody ? t("还原") : t("全屏") }}</span>
              </div>
            </el-button>
            <div class="screen-tip dfc" v-if="showScreenTip">
              <img
                src="//oss.dianleida.net/1688-web/images/hand.png"
                alt=""
                width="32"
                class="dfx-w32"
              />
              <span class="no-shk dfx-ml-5">{{
                fullscreenBody ? t("点击可还原全屏") : t("点击可展开全屏")
              }}</span>
              <i
                class="el-icon-close dfx-f-15 dfx-ml-10 curp"
                @click="closeScreenTip"
              ></i>
            </div>
          </div>
          <el-button
            size="small"
            @click="
              $utils.openUrl(
                'https://www.yuque.com/akeake-sfyp2/mg8av9/usroelnshgko3qr3?singleDoc#'
              )
            "
            ><i
              class="dfx-iconfont icon-xuanfu-caozuoshouce dfx-mr-4 dfx-c-them"
            ></i
            >{{ t("教程") }}</el-button
          >
          <Kefu size="small" class="dfx-mx-12" />
          <el-button
            size="small"
            @click="$router.push('/apply/personalManage/toolOrder')"
            ><i
              class="el-icon-shopping-cart-2 dfx-mr-4 dfx-f-16 dfx-c-danger"
            ></i
            >{{ t("购买") }}</el-button
          >
          <!-- <el-button size="small" @click="buyPackage()"
            ><i
              class="dfx-iconfont icon-dinggouguanli dfx-mr-4 dfx-f-16 dfx-c-them"
            ></i
            >增值包购买</el-button
          > -->
          <!-- <el-button size="small" @click="bindPhone"
            ><i class="el-icon-mobile-phone dfx-mr-4 dfx-f-16"></i
            >绑定手机</el-button
          > -->
          <UserInfo class="dfx-ml-12 dfx-f-14 dfx-h36 dfx-lh-36" />
        </div>
        <div class="dfx-view-router">
          <router-view />
        </div>
      </el-main>
    </el-container>
    <!-- <Login ref="Login" /> -->
    <AddShop ref="AddShop" />
    <PackageDialog ref="PackageDialog" />
    <PackageTipDialog ref="PackageTipDialog" />
    <meituDialog ref="meituDialog" />
    <ProgressDialog ref="ProgressDialog" />
    <!-- <BindAccount ref="BindAccount" /> -->
  </el-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "my-layout",
  components: {
    Aside: () => import("./components/Aside.vue"),
    Headers: () => import("./components/Headers.vue"),
    UserInfo: () => import("@/components/UserInfo.vue"),
    Kefu: () => import("@/components/Kefu.vue"),
    // Login: () => import("@/components/Login.vue"),
    // BindAccount: () => import("@/components/BindAccount.vue"),
    PackageTipDialog: () => import("@/components/PackageTipDialog.vue"),
    PackageDialog: () => import("@/components/PackageDialog.vue"),
    meituDialog: () => import("@/components/meitu/meituDialog.vue"),
    ProgressDialog: () => import("@/components/ProgressDialog.vue"),
    AddShop: () =>
      import("@/views/shop-manage/platform-components/AddShop.vue"),
  },
  data() {
    return {
      bgColog: "var(--default-bg-color)",
      showScreenTip: true,
    };
  },
  computed: {
    ...mapState({
      showHeader: (state) => state.common.showHeader,
      asideCollapse: (state) => state.common.asideCollapse,
    }),
    asideWidth() {
      return this.asideCollapse ? "60px" : "190px";
    },
  },
  mounted() {
    if (sessionStorage.getItem("showScreenTip") === "false") {
      this.showScreenTip = false;
    }
    this.$bus.$on("addShop", this.AddShop);
    this.$bus.$on("buyPackage", this.buyPackage);
    this.$bus.$on("meitu", this.meituHandle);
    this.$bus.$on("progress", this.progressHandle);
  },
  destroyed() {
    this.$bus.$off("buyPackage", this.AddShop);
    this.$bus.$off("meitu", this.meituHandle);
    this.$bus.$off("progress", this.progressHandle);
  },
  methods: {
    handleFullScreen() {
      window.parent.postMessage(
        {
          type: "fullscreen",
          isFullscreen: !this.fullscreenBody, // 当前是否处于全屏状态
          // 其他自定义数据
        },
        "*"
      );
      this.$store.commit("setFullscreen", !this.fullscreenBody);
    },
    bindPhone() {
      this.$refs.BindAccount.show();
    },
    AddShop(platform) {
      this.$refs.AddShop.show({
        platform,
        callBack: async () => {
          await this.$store.dispatch("getApplyShopList", { reFetch: true });
          this.$forceUpdate();
        },
      });
    },
    buyPackage(showKeys) {
      // showKeys 显示增值包的内容
      this.$refs.PackageDialog.show({
        showKeys,
        callBack: () => {
          this.$store.dispatch("getPackageInfo");
        },
      });
    },
    meituHandle({ data, callBack }) {
      this.$refs.meituDialog.show({ data, callBack });
    },
    progressHandle({ type = "show", text, percentage = 0 }) {
      switch (type) {
        case "show":
          this.$refs.ProgressDialog.show(text);
          break;
        case "update":
          this.$refs.ProgressDialog.update({
            text,
            percentage,
          });
          break;
        case "close":
          this.$refs.ProgressDialog.close();
          break;
      }
    },
    closeScreenTip() {
      this.showScreenTip = false;
      sessionStorage.setItem("showScreenTip", "false");
    },
  },
};
</script>

<style lang="scss" scoped>
.dfx-container {
  height: 100vh;
  overflow: hidden;
  background-color: var(--default-bg-color);
  .dfx-content {
    height: 100%;
  }
  &.dfx-container-header {
    .dfx-content {
      height: calc(100% - 60px);
    }
  }
  .screen-box {
    position: relative;
    .screen-tip {
      position: absolute;
      z-index: 5;
      top: 32px;
      left: 50px;
      width: 170px;
      background-color: var(--main-color);
      padding: 10px 10px 10px 30px;
      border-radius: 50px;
      color: #fff;
      font-size: 14px;
      img {
        position: absolute;
        left: 0;
        top: -2px;
        animation: bounce-scale 1.5s ease-in-out infinite;
      }
    }
  }
  .dfx-aside {
    display: grid;
    grid-template-rows: 74px 1fr;
    box-sizing: border-box;
    .logo {
      text-align: center;
      margin: 10px 10%;
      padding: 10px 0;
      position: sticky;
      top: 0;
      z-index: 3;
      background-color: var(--default-bg-color);
    }
    height: 100%;
    overflow: hidden auto;
    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
  }
  .dfx-views {
    padding: 0;
    position: relative;
    .dfx-view-router {
      height: calc(100% - 36px - 20px);
      border-radius: 8px 8px 0 0;
      overflow: auto;
    }
  }
}
</style>
